import { useSearch } from "@tanstack/react-router";
import { Button } from "antd";
import { useGetOutgoingPostbackQuery } from "api/TenantSlug/OutgoingPostback/hooks.ts";
import { OutgoingPostbackTestForm } from "components/Forms/OutgoingPostbackTestForm/OutgoingPostbackTestForm.tsx";
import { Drawer } from "components/UI/Drawer";
import { DrawerContent } from "components/UI/DrawerContent/DrawerContent.tsx";
import { usePaldockTranslation } from "hooks/usePaldockTranslation";
import { FC } from "react";
import { DrawerId, FormId } from "types/models.ts";

import { DrawerTitle } from "../../UI/DrawerTitle/DrawerTitle.tsx";

interface SearchParams {
    [`outgoingPostbackTest-id`]: string;
}

export const OutgoingPostbackTestDrawer: FC = () => {
    const { t } = usePaldockTranslation("drawers.outgoing-postback-test");
    const id = DrawerId.OutgoingPostbackTest;

    const searchParams = useSearch({ strict: false }) as SearchParams;
    const outgoingPostbackId = searchParams[`${id}-id`];

    const getOutgoingPostbackQuery = useGetOutgoingPostbackQuery(
        outgoingPostbackId,
        {},
        {
            enabled: !!outgoingPostbackId,
        }
    );

    const outgoingPostback = getOutgoingPostbackQuery.data?.outgoingPostback;

    if (!outgoingPostback) {
        return <></>;
    }

    return (
        <Drawer
            loading={getOutgoingPostbackQuery.isLoading}
            drawerId={id}
            title={<DrawerTitle mainTitle={outgoingPostback.name} subTitles={[]} />}
            extraButtons={
                <Button size={"large"} htmlType="submit" type={"primary"} form={FormId.OutgoingPostbackTestForm}>
                    {t("actions.run_test")}
                </Button>
            }
        >
            <DrawerContent>
                <OutgoingPostbackTestForm outgoingPostback={outgoingPostback} />
            </DrawerContent>
        </Drawer>
    );
};
